/* 上传灵感源素材 */
<template>
  <Modal
    v-model="collectMdl"
    footer-hide
    id="ModalUser"
    width="740"
    :mask-closable="false"
    :closable="true"
    class-name="vertical-center-modal fav"
  >
    <div slot="header" style="padding-left:32px;text-align:center" class="fav-header">
      {{ title }}
    </div>
    <div class="userUpload">
      <z-upload
        v-if="Object.keys(ossKey).length > 0"
        v-show="!collectionId && collectMdl"
        style="display:inline-block;float:left;"
        :type="10"
        :format="['jpg', 'jpeg', 'png']"
        :multiple="false"
        @success="handleSuccess"
        :maxSize="5120"
        :ossKey="ossKey"
        :progressBar="true"
      >
        <div class="left" :class="error.imgNull ? 'leftRed' : ''">
          <div v-if="!imgData">
            <span class="button_type">
              <!-- <i class="iconfont icon-tianjia"></i> -->
              添加图片
            </span>
            <p class="title">拖拽图片到该区域，完成上传</p>
            <p class="desc">支持单张10M以内图片上传</p>
          </div>
          <div class="bottomDesc">
            上传图片通过审核后发布至{{ type === 1 ? '灵感源' : '产品库' }}
          </div>
          <div class="bottomDesc bottomDescRed" v-if="error.imgNull">
            请添加图片
          </div>
          <div class="imgCon" v-if="imgData">
            <img :src="ossUrl + imgData.key" alt />
          </div>
        </div>
      </z-upload>
      <div
        class="left"
        v-if="collectionId"
        :class="error.imgNull ? 'leftRed' : ''"
        slot="style"
      >
        <div class="imgCon" v-if="imgData">
          <img :src="ossUrl + imgData.key" alt />
        </div>
      </div>

      <div class="right">
        <!-- <div class="right-title"> {{ title }}</div> -->
        <div class="right-product" v-if="type === 1 || type === 3">
          <div class="item">
            <p class="text">图片描述：</p>
            <p class="input">
              <textarea
                placeholder="请输入图片描述"
                maxlength="500"
                v-model="inspiration.imgDsc"
              ></textarea>
            </p>
          </div>
          <div class="item">
            <p class="text">图片标签：</p>
            <p class="input">
              <input
                @keyup.enter="newTarget"
                type="text"
                maxlength="8"
                placeholder="输入文字，按回车以生成标签(最多八个字符)"
                v-model="imgTarget"
              />
            </p>
            <div class="target">
              <Tag
                closable
                :fade="false"
                @on-close="closeTarget(index)"
                v-for="(item, index) in inspiration.imgTargetData"
                :key="index"
                color="warning"
                >{{ item }}</Tag
              >
            </div>
          </div>
        </div>
        <div class="right-product" v-if="type === 2 || type === 4">
          <div class="item">
            <p class="text">
              <span>*</span>名称：
              <span v-if="error.imgName">图片名称不能为空，且少于20个字符</span>
            </p>
            <p class="input">
              <input maxlength="20" type="text" v-model="prudtctData.name" />
            </p>
          </div>
          <div class="item">
            <p class="text">
              <span>*</span>材质：
              <span v-if="error.material">请填写单品材质</span>
            </p>
            <p class="input">
              <input
                type="text"
                maxlength="20"
                v-model="prudtctData.material"
              />
            </p>
          </div>
          <!-- <div class="item" >
            <p class="text">
              <span>*</span>规格1：
              <span v-if="error.size">请填写单品规格</span>
            </p>
            <p class="input">
              <input type="text" maxlength="100" v-model="prudtctData.size">
            </p>
          </div> -->
          <div class="item">
            <p class="text">
              <span>*</span>尺寸：
              <span v-if="error.size">请填写正确单品规格</span>
            </p>
            <div class="size-group">
              <ButtonGroup style="margin-bottom:10px;">
                <Button
                  @click="changeSizeType(0)"
                  :type="sizeType === 0 ? 'primary' : 'default'"
                  >&nbsp;&nbsp;常规&nbsp;&nbsp;</Button
                >
                <Button
                  @click="changeSizeType(1)"
                  :type="sizeType === 1 ? 'primary' : 'default'"
                  >自定义</Button
                >
              </ButtonGroup>

              <div class="sizeList">
                <Row
                  v-if="sizeType === 1"
                  :gutter="16"
                  type="flex"
                  justify="center"
                  align="middle"
                  style="margin-top:5px;"
                  v-for="(lists, index) in sizeList"
                  :key="index"
                >
                  <Col span="7" v-for="(item, i) in lists" :key="i">
                    <Input
                      v-model="item.value"
                      :maxlength="20"
                      :placeholder="item.label + '(mm)'"
                      @on-keyup="
                        item.value = Number(item.value)
                          ? Math.abs(item.value)
                          : ''
                      "
                    />
                  </Col>
                  <Col span="3">
                    <Button
                      v-if="sizeList.length > 1"
                      type="error"
                      size="small"
                      @click="deleteGroup(index)"
                      >删除</Button
                    >
                  </Col>
                </Row>
                <Button
                  v-if="sizeList && sizeList.length < 6 && sizeType === 1"
                  style="margin-top:10px;display:block;"
                  @click="addGroup"
                  icon="md-add"
                  >添加</Button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="userUploadBottom">
        <Button type="primary" @click="submit">完成</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash'
import ZUpload from '../upload/upload'

const initSize = [
  { value: '', key: 'W', label: '宽', shapeId: 1, shapeParamId: 1, type: 1 },
  { value: '', key: 'D', label: '深', shapeId: 1, shapeParamId: 2, type: 1 },
  { value: '', key: 'H', label: '高', shapeId: 1, shapeParamId: 3, type: 1 },
]

export default {
  name: 'ZUserupload',
  data() {
    return {
      collectMdl: false,
      title: '',
      imgData: null,
      progress: 0,
      type: 1, //1.上传灵感源  2.上传单品  3.修改收藏灵感源 4.编辑产品
      imgTarget: '',
      collectionId: '',
      error: {
        imgNull: false,
        imgName: false,
        size: false,
        material: false,
      },
      prudtctData: {
        name: '',
        material: '常规',
      },
      sizeList: [],
      sizeType: 1, //规格tab  0 常规  1 自定义
      inspiration: {
        imgDsc: '',
        imgTargetData: [],
      },
      tempData: null,
    }
  },
  props: {
    ossKey: {
      type: Object,
      default: function() {
        return {}
      },
    },
    ossUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    newTarget() {
      if (!this.imgTarget) {
        this.$Message.warning('请输入标签名称')
        return
      }
      if (this.inspiration.imgTargetData.length > 7) {
        this.$Message.warning('标签个数最多不能超过8个')
        return
      }
      if (this.inspiration.imgTargetData.indexOf(this.imgTarget) > -1) {
        this.$Message.warning('标签不能重复')
        return
      }
      this.inspiration.imgTargetData.push(this.imgTarget)
      this.imgTarget = ''
    },
    closeTarget(index) {
      if (index > -1) {
        this.inspiration.imgTargetData.splice(index, 1)
      }
    },
    handleSuccess(file) {
      if (!file) {
        this.$Message.error('上传失败,请重新上传')
        this.progress = 0
        return
      }
      this.imgData = file.data[0]
      this.inspiration.imgDsc = this.imgData.name
      this.prudtctData.name = this.imgData.name
      this.error.imgNull = false
      this.progress = 0
    },
    close() {
      this.collectMdl = false
    },
    open(type, params = '', collectionId = '') {
      this.sizeList = []
      this.type = type
      this.collectionId = collectionId
      // this.title = type === 1 ? "上传灵感源" : "上传产品";
      switch (type) {
        case 1:
          this.title = '上传灵感源'
          this.imgData = params.inspirationFile
          this.inspiration.imgDsc = params.collectorDescribe
          this.inspiration.imgTargetData = params.labels || []
          break
        case 2:
          this.title = '上传单品'
          this.prudtctData.name = params.name
          this.prudtctData.size = params.size
          this.prudtctData.material = params.material || '常规'
          this.imgData = params.coverFile
          break
        case 3:
          this.title = '编辑灵感源'
          this.imgData = params.inspirationFile
          this.tempData = { ...params }
          this.inspiration.imgDsc = params.collectorDescribe
          this.inspiration.imgTargetData = params.labels || []
          if (
            document.getElementsByClassName('zAfifx') &&
            document.getElementsByClassName('zAfifx')[0]
          ) {
            document.getElementsByClassName('zAfifx')[0].style.zIndex = 0
          }
          break
        case 4:
          this.title = '编辑产品'
          this.imgData = params.coverFile
          this.tempData = { ...params }
          this.prudtctData.name = params.name
          this.prudtctData.size = params.size
          this.prudtctData.material = params.material
          if (
            document.getElementsByClassName('zAfifx') &&
            document.getElementsByClassName('zAfifx')[0]
          ) {
            document.getElementsByClassName('zAfifx')[0].style.zIndex = 0
          }
          break
      }

      if (params.shapeParamSizeList && params.shapeParamSizeList.length > 0) {
        this.sizeList = params.shapeParamSizeList
        this.sizeType = 1
      } else {
        this.addGroup()
        this.sizeType = 0
      }

      // this.sizeType = params.shapeParamSizeList&&params.shapeParamSizeList.length > 0 ? 1 : 0
      // this.sizeList = params.shapeParamSizeList&&params.shapeParamSizeList.length > 0 ? params.shapeParamSizeList : new Array(initSize)
      // if (params) {
      //   type === 2 ? (this.prudtctData.name = params.name) : "";
      //   type === 2 ? (this.prudtctData.size = params.size) : "";
      //   type === 2 ? (this.prudtctData.material = params.material) : "";
      //   type === 2 ? (this.imgData = params.coverFile) : "";
      //   type === 1 ? (this.imgData = params.inspirationFile) : "";
      //   type === 1 ? (this.inspiration.imgDsc = params.describe) : "";
      //   type === 1
      //     ? (this.inspiration.imgTargetData = params.labels || [])
      //     : "";
      // }
      this.error = {
        imgNull: false,
        imgName: false,
        size: false,
        material: false,
      }
      this.collectMdl = true
    },
    judjeSizeType() {
      if (this.sizeType === 1) {
        // 判定是否填写值
        let isNoValue = []
        this.sizeList.forEach((item) => {
          const isValue = item.filter((_list) => {
            return !_list.value || _list.value < 1
          })[0]
          isValue && isNoValue.push(isValue)
        })
        if (isNoValue.length === 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    submit() {
      if (!this.imgData) {
        this.error.imgNull = true
        return
      }
      if (
        ((this.type === 2 || this.type === 4) && !this.prudtctData.name) ||
        ((this.type === 2 || this.type === 4) &&
          this.prudtctData.name.length > 19)
      ) {
        this.error.imgName = true
        return
      }
      if (
        (this.type === 2 || this.type === 4) &&
        this.sizeType == 1 &&
        !this.judjeSizeType()
      ) {
        this.error.size = true
        return
      }
      if ((this.type === 2 || this.type === 4) && !this.prudtctData.material) {
        this.error.material = true
        return
      }
      if (!this.collectionId) {
        /* 上传产品 */
        if (this.type === 2) {
          let data = {
            name: this.prudtctData.name,
            material: this.prudtctData.material || '常规',
            partFiles: [{ ...this.imgData }],
          }
          if (this.sizeType == 1) {
            ;(data.shapeId = 1), (data.shapeParamSizeList = this.sizeList)
          }

          this.$emit('uploadHanldeEmit', data, 'uploadProduct')
          //   this.$refs.collector.open(data, "uploadProduct");
          this.collectMdl = false
        }

        /* 上传灵感源 */
        if (this.type === 1) {
          let data = {
            inspiration: {
              describe: this.inspiration.imgDsc,
              labels: this.inspiration.imgTargetData,
              inspirationFile: this.imgData,
            },
          }
          this.$emit('uploadHanldeEmit', data, 'uploadInspiration')
          //   this.$refs.collector.open(data, "uploadInspiration");
          this.collectMdl = false
        }
      } else {
        let params = {
          describe: this.inspiration.imgDsc,
          material: this.prudtctData.material,
          name: this.prudtctData.name,
          size: this.prudtctData.size,
          labels: this.inspiration.imgTargetData,
          type: this.type === 1 ? 3 : 1,
        }

        /* 修改灵感源 */
        if (this.type === 3) {
          params = {
            inspiration: {
              describe: this.inspiration.imgDsc,
              labels: this.inspiration.imgTargetData,
              inspirationFile: this.imgData,
              id: this.tempData.id,
              origin: this.tempData.origin,
              phone: this.tempData.phone,
              status: this.tempData.status,
              weightValue: this.tempData.weightValue,
              workInspirationId: this.tempData.workInspirationId,
              type: 3,
            },
          }
        }
        /* 修改单品 */
        if (this.type === 4) {
          params = {
            describe: this.inspiration.imgDsc,
            material: this.prudtctData.material,
            name: this.prudtctData.name,
            labels: this.inspiration.imgTargetData,
            type: 1,
            id: this.tempData.id,
            origin: this.tempData.origin,
            phone: this.tempData.phone,
            status: this.tempData.status,
            weightValue: this.tempData.weightValue,
            workInspirationId: this.tempData.workInspirationId,
          }
          if (this.sizeType == 1) {
            ;(params.shapeId = 1), (params.shapeParamSizeList = this.sizeList)
          }
        }

        /* 去修改 */
        this.$emit('modifyUpload', {
          collectionId: this.collectionId,
          params: params,
        })

        this.collectMdl = false

        // api.inspirations
        //   .put_collection_detail(this.collectionId, params)
        //   .then(res => {
        //     this.$Message.success("修改成功");
        //     this.$emit("upload");
        //     this.collectMdl = false;
        //   });
      }
      if (
        document.getElementsByClassName('zAfifx') &&
        document.getElementsByClassName('zAfifx')[0]
      ) {
        document.getElementsByClassName('zAfifx')[0].style.zIndex = 5000
      }
    },
    changeSizeType(val) {
      this.sizeType = val
      if (val === 0) {
        this.error.size = false
      }
    },
    addGroup() {
      let param = _.cloneDeep(initSize)
      this.sizeList.push(param)
    },
    deleteGroup(index) {
      this.sizeList.splice(index, 1)
    },
  },
  watch: {
    'prudtctData.name': function() {
      if (this.prudtctData.name) {
        this.error.imgName = false
      }
    },
    'prudtctData.size': function() {
      if (this.prudtctData.size) {
        this.error.size = false
      }
    },
    'prudtctData.material': function() {
      if (this.prudtctData.material) {
        this.error.material = false
      }
    },
    collectMdl: function() {
      if (!this.collectMdl) {
        this.prudtctData.name = ''
        this.prudtctData.size = '常规'
        this.prudtctData.material = '常规'
        this.inspiration.imgDsc = ''
        this.inspiration.imgTargetData = []
        this.imgTarget = ''
        this.imgData = null
        this.$emit('closedHandle')
      }
    },
  },
  components: {
    ZUpload,
    // collector
  },
  created() {
    this.addGroup()
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fav {
  .fav-content-right {
    overflow: auto;
  }
  &-header {
    font-size: 20px;
    color: #353838;
    letter-spacing: 4px;
    text-align: left;
    position: relative;
    i {
      position: absolute;
      top: -10px;
      right: 20px;
      cursor: pointer;
      &:after {
        content: '';
        position: absolute;
        top: -10px;
        right: -10px;
        bottom: -10px;
        left: -10px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .userUpload {
    min-height: 500px;
    padding-bottom: 80px;
    &::after {
      content: '';
      display: block;
      clear: both;
      font-size: 0;
      line-height: 0;
    }
    .left {
      width: 273px;
      height: 360px;
      float: left;
      cursor: pointer;
      border: 1px dashed #C8CDD5;
      text-align: center;
      position: relative;
      background: #F7F7F8;
      .imgCon {
        width: 100%;
        height: 100%;
        line-height: 360px;
        > img {
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
          margin-top: -5px;
          object-fit: contain;
        }
      }

      .button_type {
        background: #fff;
        border-radius: 3px;
        font-size: 14px;
        color: #1F1F1F;
        font-weight: bold;
        display: inline-block;
        padding: 2px 12px;
        margin-top: 135px;
        border-radius: 20px;
      }
      p {
        height: 25px;
      }
      p.title {
        text-align: center;
        font-size: 12px;
        color: #373737;
        margin-top: 15px;
      }
      p.desc {
        font-size: 11px;
        color: #bfbfbf;
      }
      .bottomDesc {
        font-size: 10px;
        position: absolute;
        bottom: -30px;
        width: 300px;
        left: -14px;
        font-weight: 400;
color: #747474;
      }
      .bottomDescRed {
        bottom: -50px;
        color: #e14b5d;
      }
    }
    .leftRed {
      border: 1px dashed #e14b5d;
    }
    .right {
      float: left;
      margin-left: 23px;
      width: 340px;
      text-align: left;
      .item {
        margin-bottom: 20px;
        .text {
          font-size: 14px;
          color: #373737;
          margin-bottom: 10px;
          > span {
            color: #e14b5d;
          }
        }
        .input {
          input {
            width: 100%;
            height: 42px;
            border: none;
            background: #efefef;
            padding: 0 10px;
          }
          textarea {
            width: 100%;
            height: 200px;
            border: none;
            background: #efefef;
            padding: 10px;
            resize: none;
            &:focus {
              box-shadow: none;
              outline: none;
            }
          }
        }
        .target {
          margin-top: 10px;
        }
      }
      .size-group {
        margin-top: 20px;
      }
    }
    .userUploadBottom {
      width: 100%;
      text-align: center;
      float: left;
      position: absolute;
      bottom: 30px;
      left: 0;
      margin-top: 30px;

      &:hover {
        opacity: 0.8;
      }
      button {
        background: #313131;
        cursor: pointer;
        width: 140px;
        height: 45px;
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}
</style>
